<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <footer :class="$style.footer">
    <div class="container ">
      <div class="footer-wrapper">
        <div class="footer-column--1">
          <img class="footer-logo" src="@assets/dingbeauty-images/home/logo_white.svg" alt="logo" />
          <p class="footer-title">宇嵐有限公司</p>
          <p>諮詢專線 | (02) 2531-6628</p>
          <p>客服信箱 | service@dingbeauty.com</p>
          <p>台北辦公室 | 台北市萬華區成都路67號4樓之2B</p>
          <p>台中辦公室 | 台中市西屯區朝富路213號</p>
        </div>

        <div class="footer-column--2">
          <p class="footer-title">關於Ding Beauty</p>
          <p class="content">
            讓忙於經營美容服務的繁瑣日常變成過去式！ Ding Beauty 品牌初衷是為解決您的痛點，致力打造最優質的預約管理系統！<br />
            現代化您的營運流程、簡化那些繁瑣的管理工作，幫助美容服務更容易，工作日常也變得更加輕鬆！
          </p>
          <div>
            <p>隱私權政策 Privacy policy</p>
            <p>使用者條款 Term & conditions</p>
          </div>
        </div>

        <div class="footer-column--3">
          <div class="footer-btn" @click="openNewTab('https://www.instagram.com/ipetbooking')">
            <img src="@assets/dingbeauty-images/home/contact/line.svg" alt="" />
            <p>Line官方帳號</p>
          </div>
          <div class="footer-btn" @click="openNewTab('https://www.instagram.com/ipetbooking')">
            <img src="@assets/dingbeauty-images/home/contact/instgram.svg" alt="" />
            <p>Instagram</p>
          </div>
          <div class="footer-btn" @click="openNewTab('https://www.facebook.com/ipetbooking')">
            <img src="@assets/dingbeauty-images/home/contact/fb.svg" alt="" />
            <p>Facebook</p>
          </div>
        </div>
      </div>

      <div class="divider"></div>
      <p class="copyright">Copyright © 2023 Ding Beauty. All rights reserved.</p>
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    openNewTab(url) {
      window.open(url, '_blank')
    },
  },
}
</script>

<style lang="scss" module>
$color-primary: #e3c192;

.footer {
  background-color: $color-primary;
  font-size: 14px;
  color: #fff;
  padding: 60px 0 20px 0;

  :global {
    .divider {
      height: 1px;
      background-color: #fff;
      margin-top: 60px;
      margin-bottom: 20px;
    }

    .copyright {
      font-size: 12px;
      text-align: center;
    }

    .footer-wrapper {
      display: grid;
      gap: 48px;
    }

    p {
      margin: 0;
      line-height: 2;
      text-align: center;
    }

    .footer-title {
      font-size: 16px;
      margin-bottom: 12px;
      font-weight: 500;
    }

    .footer-column--1 {
      display: grid;
      justify-items: center;

      img {
        margin-bottom: 24px;
      }
    }

    .footer-column--2 {
      display: grid;
      justify-items: center;

      .content {
        text-align: center;
        margin-bottom: 12px;
        max-width: 400px;
      }
    }

    .footer-column--3 {
      display: grid;
      gap: 20px;
      justify-items: center;

      .footer-btn {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 8px;
        border: 1px solid #fff;
        font-size: 16px;
        gap: 8px;
        cursor: pointer;

        img {
          width: 18px;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  .footer {
    :global {
      p {
        text-align: left;
      }

      .footer-title {
        font-size: 18psepx;
      }

      .footer-wrapper {
        grid-template-columns: 1fr 1fr;
        .footer-column--1 {
          justify-items: left;
        }

        .footer-column--2 {
          justify-items: left;

          .content {
            text-align: left;
          }
        }

        .footer-column--3 {
          grid-column: 1 / 3;
        }
      }
    }
  }
}

@media (min-width: 992px) {
  .footer {
    padding: 100px 0 40px 0;

    :global {
      .divider {
        text-align: center;
        margin-top: 100px;
        margin-bottom: 40px;
      }

      .copyright {
        font-size: 16px;
      }

      .footer-wrapper {
        grid-template-columns: repeat(3, 1fr);
        gap: 40px;

        .footer-column--1 {
          img {
            margin-bottom: 48px;
          }
        }

        .footer-column--2 {
          gap: 20px;
        }

        .footer-column--3 {
          grid-column: 3 / 4;
          display: block;

          .footer-btn {
            margin-bottom: 20px;
          }
        }
      }
    }
  }
}
</style>
